import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { useMutation, useQueryClient } from 'react-query';
import { BASE_KEY } from './backgroundKeys';
import { IBackgroundResponse } from './useQueryBackgrounds';

export interface IDefaultBackgroundParams {
  id: number;
}

export const setDefaultBackground = async (
  params: IDefaultBackgroundParams
): Promise<IBackgroundResponse> => {
  const { id } = params;
  const response = await EXPRESS_API.patch(`/backgrounds/${id}/default`);
  return response.data;
};

export const useDefaultBackgroundMutation = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { showError } = useToastError();
  return useMutation(setDefaultBackground, {
    onSuccess: async () => {
      await queryClient.refetchQueries({
        queryKey: BASE_KEY,
        exact: false,
      });
      onSuccess && onSuccess();
      successToast({
        title: `Default background has been successfully updated!`,
      });
    },
    onError: error =>
      showError(
        error ||
          `An error occurred while trying to update the default background!`
      ),
  });
};
